/** @jsx jsx */

import { format, parseISO } from 'date-fns';

import { css, jsx } from '@emotion/core';
import { Text } from '@zapier/design-system';

import { getTimeZoneShortLabel } from './utils';
import type { Version } from './types';

const Styles = {
  root: css`
    display: flex;
    flex-direction: column;
  `,
};

type Props = {
  version: Version;
};

function ColumnLastUpdated({ version }: Props) {
  const updatedAt = parseISO(version.updatedAt);
  const timeZoneLabel = getTimeZoneShortLabel(updatedAt);
  return (
    <div css={Styles.root}>
      <Text type="Body1">
        {format(updatedAt, 'yyyy-MM-dd HH:mm:ss xxx')}
        {timeZoneLabel ? ` (${timeZoneLabel})` : ''}
      </Text>
      <Text color="UiPrimaryStrongest">
        <a href={`mailto:${version.authorEmail}`} target="_blank">
          {version.authorEmail}
        </a>
      </Text>
    </div>
  );
}

export default ColumnLastUpdated;
